import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-cambiar-clave',
  templateUrl: './cambiar-clave.component.html',
  styleUrls: ['./cambiar-clave.component.css']
})
export class CambiarClaveComponent implements OnInit {

  formulario: FormGroup;
  loading: boolean = false;
  hash: string = '';
  categoria: string = '';
  login: string = '';
  firstName: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _auth: AuthService,
    private _utils: UtilsService
  ) { }

  ngOnInit(): void {
    // Obtener el hash (secuencia random) y la categoría de los parámetros de la ruta
    this.hash = this.route.snapshot.paramMap.get('hash') || '';
    this.categoria = this.route.snapshot.paramMap.get('categoria') || '';

    if (!this.hash) {
      this._utils.mensajeErrorVisto('El link de recuperación no es válido.');
      this.router.navigate(['/login']);
      return;
    }

    this.formulario = this.fb.group({
      newPassword: ['', [Validators.required, this.validatePassword]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });

    this.cargarUsuario();
  }

  cargarUsuario(): void {
    this._auth.obtenerUsuarioPorHash(this.hash).subscribe({
      next: (response: any) => {
        const data = response?.respuesta || response;
        this.login = data?.login || '';
        this.firstName = data?.firstName || '';
      },
      error: (error) => {
        const mensaje = error.error?.mensaje || error.message || 'El link de recuperación no es válido o ha expirado.';
        this._utils.mensajeErrorVisto(mensaje);
        this.router.navigate(['/login']);
      }
    });
  }

  // Validador personalizado para contraseña
  validatePassword(control: any): { [key: string]: boolean } | null {
    const password = control.value;
    
    if (!password) {
      return null;
    }

    // Mínimo 8 caracteres
    if (password.length < 8) {
      return { minLength: true };
    }

    // Al menos una letra mayúscula
    if (!/[A-Z]/.test(password)) {
      return { uppercase: true };
    }

    // Al menos una letra minúscula
    if (!/[a-z]/.test(password)) {
      return { lowercase: true };
    }

    // Al menos un número
    if (!/[0-9]/.test(password)) {
      return { number: true };
    }

    // Al menos un carácter especial
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      return { special: true };
    }

    return null;
  }

  // Validador para confirmar que las contraseñas coinciden
  passwordMatchValidator(formGroup: FormGroup): { [key: string]: boolean } | null {
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      return { passwordMismatch: true };
    }

    return null;
  }

  onCambiarClave(): void {
    if (this.formulario.invalid) {
      this._utils.mensajeErrorVisto('Por favor, complete todos los campos correctamente y asegúrese de que las contraseñas coincidan.');
      return;
    }

    this.loading = true;
    const newPassword = this.formulario.get('newPassword')?.value;

    this._auth.cambiarClave(this.hash, newPassword).subscribe({
      next: (response: any) => {
        this.loading = false;
        this._utils.mensajeOKToast(
          'Contraseña cambiada exitosamente. Por favor, inicie sesión con su nueva contraseña.',
          4000
        );
        this.router.navigate(['/login']);
      },
      error: (error) => {
        this.loading = false;
        const mensaje = error.error?.mensaje || error.message || 'Error al cambiar la contraseña.';
        this._utils.mensajeErrorVisto(mensaje);
      }
    });
  }

  volverAlLogin(): void {
    this.router.navigate(['/login']);
  }

  // Métodos para mostrar errores de validación
  getPasswordError(): string {
    const newPassword = this.formulario.get('newPassword');
    
    if (newPassword?.hasError('required')) {
      return 'La contraseña es requerida';
    }
    if (newPassword?.hasError('minLength')) {
      return 'La contraseña debe tener al menos 8 caracteres';
    }
    if (newPassword?.hasError('uppercase')) {
      return 'La contraseña debe contener al menos una letra mayúscula';
    }
    if (newPassword?.hasError('lowercase')) {
      return 'La contraseña debe contener al menos una letra minúscula';
    }
    if (newPassword?.hasError('number')) {
      return 'La contraseña debe contener al menos un número';
    }
    if (newPassword?.hasError('special')) {
      return 'La contraseña debe contener al menos un carácter especial';
    }
    
    return '';
  }

  getPasswordMismatchError(): string {
    if (this.formulario.hasError('passwordMismatch')) {
      return 'Las contraseñas no coinciden';
    }
    return '';
  }
}
